import { Modal } from '@components/Modal'
import { Button, OldText } from '@gassan-ui'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

type FloatingServiceMenuModalProps = {
  handleRequestClose: () => void
}

export const FloatingServiceMenuModal: FC<FloatingServiceMenuModalProps> = ({
  handleRequestClose,
}) => {
  const { t } = useTranslation('other')

  return (
    <Modal
      defaultOpen
      onOpenChange={(open) => {
        if (!open) {
          handleRequestClose()
        }
      }}
      title={t('contactModalTitle')}
    >
      <OldText variant="regular" mb="4">
        {t('contactModalDescription')}
      </OldText>
      <OldText variant="regular" mb="4">
        <span
          dangerouslySetInnerHTML={{
            __html: t('contactModalCall'),
          }}
        />
        <br />
        <span
          dangerouslySetInnerHTML={{
            __html: t('contactModalEmail'),
          }}
        />
        <br />
        <span
          dangerouslySetInnerHTML={{
            __html: t('contactModalHours'),
          }}
        />
      </OldText>
      <div className="mt-auto">
        <div className="md:none block">
          <Button variant="dark" as="link" className="mb-3 min-w-full" href="tel:+31206225333">
            {t('callCta')}
          </Button>
        </div>
        <Button
          variant="light"
          as="link"
          className="min-w-full"
          href={t('contactLink')}
          target="_blank"
        >
          {t('contactLinkTitle')}
        </Button>
      </div>
    </Modal>
  )
}
